import { render, staticRenderFns } from "./publication-report.vue?vue&type=template&id=40b21112&scoped=true&"
import script from "./publication-report.vue?vue&type=script&lang=js&"
export * from "./publication-report.vue?vue&type=script&lang=js&"
import style0 from "./publication-report.vue?vue&type=style&index=0&id=40b21112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b21112",
  null
  
)

export default component.exports